export const width = 469;
export const height = 389;
export default __webpack_public_path__ + "static/data-extraction-rafiki.2e1c3e3e.svg";